var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "drag_handle",
  "use": "drag_handle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"drag_handle\"><path fill=\"none\" d=\"M0 0h24v24H0z\" /><path d=\"M20 9H4v2h16V9zM4 15h16v-2H4v2z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol